import { addDays, isBefore } from 'date-fns';

import { CalendarType, DatePickerDate } from '../types';

export default function isForwardDisabled({
  calendars,
  maxDate,
}: {
  calendars: Pick<CalendarType, 'lastDayOfMonth'>[];
  maxDate?: DatePickerDate | null;
}) {
  if (!maxDate) {
    return false;
  }

  const { lastDayOfMonth } = calendars[calendars.length - 1];
  const lastDayOfMonthPlusOne = addDays(lastDayOfMonth, 1);

  if (isBefore(maxDate, lastDayOfMonthPlusOne)) {
    return true;
  }

  return false;
}
